import React from 'react';
import PropTypes from 'prop-types';
import Styled from '@emotion/styled';
import Upload from '../Icons/Upload';
import ValidationError from '../ValidationError';
import acceptFiles from '../lib/acceptFiles';

const DragAndDropWrapper = Styled.div`
  width: 100%;
  min-height: 300px;
  display: block;
  position: relative;
  cursor: pointer;
  height: 100%;
  background-color: rgba(240, 240, 240, 0.3);
  border: 1px dashed #404040;
  color: var(--mdc-theme-text-secondary-on-light, rgba(0, 0, 0, 0.54));
  font-family: Open Sans, sans-serif;
  ${(properties) => !properties.visible && `
    display: none;
  `}

`;

const DragAndDropInput = Styled.input`
  opacity: 0;
  width: 100%;
  min-height: 300px;
  cursor: pointer;
  display: block;
`;

const DragAndDropText = Styled.div`
  position: absolute;
  width: 100%;
  text-align: center;
  top: 30%;
  display: flex;
  flex-direction: column;
`;

const IconContainer = Styled.div`
  svg {
    margin: 0 auto;
  }
`;

const DragAndDrop = ({
  title,
  onChange,
  required,
  id,
  fileTypes,
  iconColor,
  visible,
  error,
  ...properties
}) => (
  <DragAndDropWrapper visible={visible}>
    <DragAndDropText>
      <IconContainer>
        <Upload
          title="Upload Image"
          width="50px"
          height="50px"
          fillColor={iconColor}
        />
      </IconContainer>
      {title}
    </DragAndDropText>
    <DragAndDropInput
      id={id}
      unknown="something"
      accept={fileTypes}
      onChange={onChange}
      required={required}
      type="file"
      {...properties}
    />
    { error && (
      <ValidationError>
        { error }
      </ValidationError>
    )}
  </DragAndDropWrapper>
);

DragAndDrop.propTypes = {
  title: PropTypes.node,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  id: PropTypes.string,
  fileTypes: PropTypes.string,
  iconColor: PropTypes.string,
  visible: PropTypes.bool,
  error: PropTypes.string,
};

DragAndDrop.defaultProps = {
  title: undefined,
  onChange: undefined,
  id: 'input-file',
  fileTypes: acceptFiles,
  required: false,
  iconColor: 'var(--grey-dark)',
  visible: true,
  error: undefined,
};

export default DragAndDrop;
